<template>
  <div class="dndList" >
    <div :style="{width:width2}"  class="dndList-list">
      <h3>可选课程</h3>
      <draggable :list="courseList2" group="article" style="height: 500px; overflow-y: scroll; border: 1px solid #bfcbd9" class="dragArea" >
        <div v-for="element in courseList2" :key="element.commodityId" class="list-complete-item" style="margin-left: 5px">
          <div class="list-complete-item-handle2" @click="pushEle(element)">
              {{ element.courseName }}
          </div>
        </div>
      </draggable>
    </div>
    <div :style="{width:width1}" class="dndList-list">
      <h3>已选课程</h3>
      <draggable :set-data="setData" :list="courseList1" group="article" style="height: 500px; overflow-y: scroll; border: 1px solid #bfcbd9" class="dragArea">
        <div v-for="element in courseList1" :key="element.commodityId" class="list-complete-item" style="margin-left: 5px">
          <div class="list-complete-item-handle">
            {{ element.courseName }}
          </div>
          <div style="position:absolute;right:0px;">
            <span style="float: right ;margin-top: -20px;margin-right:5px;" @click="deleteEle(element)">
              <i style="color:#ff4949" class="el-icon-delete" />
            </span>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'CourseList',
  components: { draggable },
  props: {
    courseList1: {
      type: Array,
      default() {
        return []
      }
    },
    courseList2: {
      type: Array,
      default() {
        return []
      }
    },
    list1Title: {
      type: String,
      default: 'list1'
    },
    list2Title: {
      type: String,
      default: 'list2'
    },
    width1: {
      type: String,
      default: '48%'
    },
    width2: {
      type: String,
      default: '48%'
    },
    height1: {
      type: String,
      default: '500px'
    },
  },
  methods: {
    isNotInList1(v) {
      return this.courseList1.every(k => v.commodityId !== k.commodityId)
    },
    isNotInList2(v) {
      return this.courseList2.every(k => v.commodityId !== k.commodityId)
    },
    deleteEle(ele) {
      for (const item of this.courseList1) {
        if (item.commodityId === ele.commodityId) {
          const index = this.courseList1.indexOf(item)
          this.courseList1.splice(index, 1)
          break
        }
      }
    },
    pushEle(ele) {
      if (this.isNotInList1(ele)) {
        this.courseList1.push(ele)
      }
    },
    setData(dataTransfer) {
      dataTransfer.setData('Text', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.dndList {
  background: #fff;
  padding-bottom: 40px;
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  .dndList-list {
    float: left;
    padding-bottom: 30px;
    &:first-of-type {
      margin-right: 2%;
    }
    .dragArea {
      margin-top: 15px;
      min-height: 50px;
      padding-bottom: 30px;
    }
  }
}

.list-complete-item {
  cursor: pointer;
  position: relative;
  font-size: 14px;
  padding: 5px 12px;
  margin-top: 4px;
  border: 1px solid #bfcbd9;
  transition: all 1s;
}

.list-complete-item-handle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 50px;
}

.list-complete-item-handle2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
}

.list-complete-item.sortable-chosen {
  background: #4AB7BD;
}

.list-complete-item.sortable-ghost {
  background: #30B08F;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}
.dragArea::-webkit-scrollbar {
  display: none;
}
</style>
